import { COLORS } from './constants.js';

export function drawBackground(ctx, width, height) {
  ctx.save();
  ctx.strokeStyle = 'rgba(213, 217, 226, 0.28)';
  ctx.lineWidth = 1;

  for (let x = 0; x <= width; x += 42) {
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, height);
    ctx.stroke();
  }

  for (let y = 0; y <= height; y += 42) {
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(width, y);
    ctx.stroke();
  }

  ctx.restore();
}

export function drawConnections(ctx, nodes, connections) {
  const nodeById = new Map(nodes.map(node => [node.id, node]));

  connections.forEach(([from, to, dashed]) => {
    const start = nodeById.get(from);
    const end = nodeById.get(to);
    if (!start || !end) return;

    ctx.save();
    ctx.beginPath();
    ctx.setLineDash?.(dashed ? [8, 8] : []);
    ctx.strokeStyle = COLORS.brand200;
    ctx.lineWidth = 2;

    const midX = (start.cx + end.cx) / 2;
    ctx.moveTo(start.cx, start.cy);
    ctx.bezierCurveTo?.(midX, start.cy, midX, end.cy, end.cx, end.cy);
    if (!ctx.bezierCurveTo) ctx.lineTo(end.cx, end.cy);
    ctx.stroke();
    ctx.setLineDash?.([]);

    ctx.fillStyle = COLORS.brand300;
    ctx.beginPath();
    ctx.arc(end.cx, end.cy, 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  });
}

export function drawNode(ctx, node, active) {
  ctx.save();
  ctx.fillStyle = active ? node.color : COLORS.white;
  ctx.strokeStyle = active ? node.color : COLORS.brand200;
  ctx.lineWidth = 1.5;
  roundedRect(ctx, node.left, node.top, node.width, node.height, 18);
  ctx.fill();
  ctx.stroke();

  ctx.fillStyle = active ? 'rgba(255,255,255,0.74)' : node.color;
  ctx.font = '700 9px Inter, system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(node.phase.toUpperCase(), node.cx, node.cy - 12);

  ctx.fillStyle = active ? COLORS.white : COLORS.brand900;
  ctx.font = '700 13px Inter, system-ui, sans-serif';
  ctx.fillText(node.label, node.cx, node.cy + 9);
  ctx.restore();
}

export function drawLabel(ctx, width, height, label) {
  ctx.save();
  ctx.fillStyle = COLORS.brand300;
  ctx.font = '700 10px Inter, system-ui, sans-serif';
  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';
  ctx.fillText(label.toUpperCase(), width - 18, height - 16);
  ctx.restore();
}

export function drawFallback(ctx, width, height, label) {
  ctx.save();
  ctx.fillStyle = COLORS.brand500;
  ctx.font = '700 13px Inter, system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(label || 'Diagram unavailable', width / 2, height / 2);
  ctx.restore();
}

function roundedRect(ctx, x, y, width, height, radius) {
  if (ctx.roundRect) {
    ctx.beginPath();
    ctx.roundRect(x, y, width, height, radius);
    return;
  }

  const right = x + width;
  const bottom = y + height;
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(right - radius, y);
  ctx.quadraticCurveTo?.(right, y, right, y + radius);
  ctx.lineTo(right, bottom - radius);
  ctx.quadraticCurveTo?.(right, bottom, right - radius, bottom);
  ctx.lineTo(x + radius, bottom);
  ctx.quadraticCurveTo?.(x, bottom, x, bottom - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo?.(x, y, x + radius, y);
  ctx.closePath();
}
